import Model from 'core/model/Model';

export default class CloudExportGcpCustomAppServiceAccount extends Model {
  get urlRoot() {
    return '/api/ui/cloudExportGcpCustomAppServiceAccount';
  }
}
